import { render, staticRenderFns } from "./MenuEsquerdo.vue?vue&type=template&id=be4928b0&scoped=true"
import script from "./MenuEsquerdo.vue?vue&type=script&lang=js"
export * from "./MenuEsquerdo.vue?vue&type=script&lang=js"
import style0 from "./MenuEsquerdo.vue?vue&type=style&index=0&id=be4928b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be4928b0",
  null
  
)

export default component.exports